import * as React from 'react';
export const embeddedCheckoutSvg = React.forwardRef(
  function embeddedCheckoutSvgInner(props, ref) {
    return /*#__PURE__*/ React.createElement(
      'svg',
      {
        ...props,
        ref: ref,
      },
      /*#__PURE__*/ React.createElement('path', {
        d: 'M0 10.25V9.4a.75.75 0 0 1 1.5 0v.85c0 .138.112.25.25.25h.85a.75.75 0 0 1 0 1.5h-.85A1.75 1.75 0 0 1 0 10.25Zm6.85.25a.75.75 0 0 1 0 1.5h-1.7a.75.75 0 0 1 0-1.5h1.7Zm3.65-.25V9.4a.75.75 0 0 1 1.5 0v.85A1.75 1.75 0 0 1 10.25 12H9.4a.75.75 0 0 1 0-1.5h.85a.25.25 0 0 0 .25-.25ZM0 6.85v-1.7a.75.75 0 0 1 1.5 0v1.7a.75.75 0 0 1-1.5 0Zm10.5 0v-1.7a.75.75 0 0 1 1.5 0v1.7a.75.75 0 0 1-1.5 0ZM0 2.6v-.85C0 .784.784 0 1.75 0h.85a.75.75 0 0 1 0 1.5h-.85a.25.25 0 0 0-.25.25v.85a.75.75 0 0 1-1.5 0Zm10.5 0v-.85a.25.25 0 0 0-.25-.25H9.4a.75.75 0 0 1 0-1.5h.85C11.216 0 12 .784 12 1.75v.85a.75.75 0 0 1-1.5 0ZM6.85 0a.75.75 0 0 1 0 1.5h-1.7a.75.75 0 0 1 0-1.5h1.7Z',
      }),
    );
  },
);
embeddedCheckoutSvg.defaultProps = {
  width: '12',
  height: '12',
  viewBox: '0 0 12 12',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var embeddedCheckout = {
  category: 'icon',
  colorable: true,
  name: 'embeddedCheckout',
  svg: embeddedCheckoutSvg,
};
